import React, { useContext } from "react";
import "./Models.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

import voyahFree from "../../assets/images/dropdown/voyahFree.webp";
import voyahDream from "../../assets/images/dropdown/voyahDream.webp";
import taishanImg from "../../assets/images/dropdown/taishan.png";
import comingSoon from "../../assets/images/models/covercar.webp";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

const Models = () => {
  const { texts } = useContext(LanguageContext);
  const nav = texts.navbar || {};
  const exp = texts.experience || {};

  return (
    <div className="modelsnavedi">
      <Navbar />

      <section className="models-section">
        <h1 className="models-title">{nav.models}</h1>

        <div className="models-row">
          <div className="model-card">
            <img src={voyahFree} alt={nav.voyahFree} />
            <h2>{nav.voyahFree}</h2>
            <div className="model-actions">
              <Link to="/voyah-free">
                <span>{nav.findOutMore}</span>
              </Link>
              <Link to="/voyah-free-build">
                <span>{nav.buildYourCar}</span>
              </Link>
            </div>
          </div>

          <div className="model-card">
            <img src={voyahDream} alt={nav.voyahDream} />
            <h2>{nav.voyahDream}</h2>
            <div className="model-actions">
              <Link to="/voyah-dream">
                <span>{nav.findOutMore}</span>
              </Link>
              <Link to="/voyah-dream-build">
                <span>{nav.buildYourCar}</span>
              </Link>
            </div>
          </div>

          <div className="model-card">
            <img src={taishanImg} alt={nav.voyahTaishan} />
            <h2>{nav.voyahTaishan}</h2>
            <div className="model-actions">
              <Link to="/voyah-taishan">
                <span>{nav.findOutMore}</span>
              </Link>
              <Link to="/voyah-taishan-build">
                <span>{nav.buildYourCar}</span>
              </Link>
            </div>
          </div>

          <div className="model-card coming-soon">
            <img src={comingSoon} alt={exp.moreModels} />
            <h2>{exp.moreModels}</h2>
            <div className="model-actions">
              <Link to="/contact">
                <span>{exp.contactUs}</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Models;
